const MIESIACE_SKROT = [
  'sty',
  'lut',
  'mar',
  'kwi',
  'maj',
  'cze',
  'lip',
  'sie',
  'wrz',
  'paź',
  'lis',
  'gru',
];

const MIESIACE_DOPELNIACZ = [
  'stycznia',
  'lutego',
  'marca',
  'kwietnia',
  'maja',
  'czerwca',
  'lipca',
  'sierpnia',
  'września',
  'października',
  'listopada',
  'grudnia',
];

/**
 * Rozbija datę "2026-07-12" na części. Zwraca null dla dat pustych lub
 * niepoprawnych — w archiwum sprzed panelu znamy przy wielu koncertach tylko rok.
 */
export function rozbijDate(iso) {
  if (typeof iso !== 'string') {
    return null;
  }

  const czesci = iso.split('-');
  if (czesci.length !== 3) {
    return null;
  }

  const rok = Number(czesci[0]);
  const miesiac = Number(czesci[1]);
  const dzien = Number(czesci[2]);

  if (!rok || !miesiac || !dzien || miesiac < 1 || miesiac > 12) {
    return null;
  }

  return {
    rok,
    dzien,
    miesiacSkrot: MIESIACE_SKROT[miesiac - 1],
    miesiacDopelniacz: MIESIACE_DOPELNIACZ[miesiac - 1],
  };
}

/** "12 lipca 2026" — używane w atrybutach dostępnościowych i w treści. */
export function formatujDatePelna(iso) {
  const data = rozbijDate(iso);
  if (!data) {
    return null;
  }

  return data.dzien + ' ' + data.miesiacDopelniacz + ' ' + data.rok;
}

/** Miejscowość wraz z krajem, jeśli koncert był poza Polską. */
export function formatujMiejsce(koncert) {
  if (!koncert.country) {
    return koncert.city;
  }

  return koncert.city + ', ' + koncert.country;
}

/** Druga linia wiersza: nazwa wydarzenia, miejsce, opis — to, co akurat jest. */
export function formatujSzczegoly(koncert) {
  return [koncert.name, koncert.venue, koncert.description]
    .filter(Boolean)
    .join(' · ');
}

/** Grupuje koncerty po roku, zachowując kolejność otrzymaną z API. */
export function pogrupujPoLatach(koncerty) {
  const grupy = [];

  koncerty.forEach(koncert => {
    const ostatnia = grupy[grupy.length - 1];

    if (ostatnia && ostatnia.rok === koncert.year) {
      ostatnia.koncerty.push(koncert);
      return;
    }

    grupy.push({ rok: koncert.year, koncerty: [koncert] });
  });

  return grupy;
}
